import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import { StoreState } from "../redux/reducers";
import { CourseType } from "./Interface";
import axios from "axios";
import { apiUrl } from "../config";
import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import Card from "../components/custom/Card";
import { StudentFeeDetails } from "../redux/actions/studentFeesDetailsAction";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Papa from "papaparse";

const TotalStudentFeesSummary = () => {
  const dispatch = useDispatch<AppDispatch>();
  const branchList = useSelector<StoreState, any[]>((state) => state.branch);
  const studentFees = useSelector<StoreState, StudentFeeDetails[]>(
    (state) => state.studentFeesReducer,
  );
  const [courseList, setCourseList] = useState<CourseType[]>([]);
  const [filteredStudents, setFilteredStudents] = useState<any>([]);
  const [branchFilter, setBranchFilter] = useState<string>("");
  const [courseFilter, setCourseFilter] = useState<string>("");
  const [batchFilter, setBatchFilter] = useState<string>("");
  const [isSearched, setIsSearched] = useState<boolean>(false);

  useEffect(() => {
    axios
      .get<{ data: CourseType[] }>(`${apiUrl}/course/`)
      .then((response) => setCourseList(response.data.data))
      .catch((error) => console.error("Error fetching courses:", error));
  }, []);

  const handleFilterChange = async () => {
    if (!branchFilter || !courseFilter || !batchFilter) {
      alert("Please select Branch, Course and Batch");
      return;
    }

    try {
      const response = await axios.get<{ data: any[] }>(
        `${apiUrl}/student/totalStudentFeesSummary/?branchId=${branchFilter}&courseId=${courseFilter}&batch=${batchFilter}`,
      );

      setFilteredStudents(response.data.data || []);
      setIsSearched(true);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const handleClear = () => {
    setBranchFilter("");
    setCourseFilter("");
    setBatchFilter("");
    setIsSearched(false);
  };
  const last10Years = Array.from(
    { length: 11 },
    (_, i) => new Date().getFullYear() - i,
  );

  const feeTitles: string[] = Array.from(
    new Set<string>(
      filteredStudents.flatMap(
        (student: any) => student.fees?.map((f: any) => f.title) || [],
      ),
    ),
  );
 const downloadPDF = () => {
  if (!filteredStudents.length) {
    alert("No data to export");
    return;
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("TOTAL WISE STUDENT FEES SUMMARY", pageWidth / 2, 12, {
    align: "center",
  });

  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");

  const branchName =
    branchList.find((b) => b.id.toString() === branchFilter)?.name || "All";

  const courseName =
    courseList.find((c) => c.id.toString() === courseFilter)?.name || "All";

  doc.text(
    `Branch: ${branchName} | Course: ${courseName} | Batch: ${
      batchFilter || "All"
    }`,
    pageWidth / 2,
    18,
    { align: "center" }
  );

  
  const head = [
    [
      { content: "S.No", },
      { content: "Admission No", },
      { content: "Name", },
      { content: "Total Due",  },
      { content: "Total Paid",},
      { content: "Total Balance",},
    ],
  ];
  const body = filteredStudents.map((student: any, index: number) => [
    index + 1,
    student.admission_number || "",
    student.student_name || "",
    (student.grand_total || 0).toFixed(2),
    (student.grand_paid || 0).toFixed(2),
    (student.grand_balance || 0).toFixed(2),
  ]);
  const grandTotal = filteredStudents.reduce(
    (sum: number, s: any) => sum + Number(s.grand_total || 0),
    0
  );

  const grandPaid = filteredStudents.reduce(
    (sum: number, s: any) => sum + Number(s.grand_paid || 0),
    0
  );

  const grandBalance = filteredStudents.reduce(
    (sum: number, s: any) => sum + Number(s.grand_balance || 0),
    0
  );

  const foot = [
    [
      {
        content: "Grand Total",
        colSpan: 3,
        styles: { halign: "right", fontStyle: "bold" },
      },
      (grandTotal).toFixed(2),
      (grandPaid).toFixed(2),
      (grandBalance).toFixed(2),
    ],
  ];

 autoTable(doc, {
  head,
  body,
  foot,
  startY: 25,
  theme: "grid",
  showFoot: "lastPage",

  styles: {
    fontSize: 8,
    cellPadding: 2,
    textColor: [0, 0, 0],
    halign: "center",
    lineColor: [0, 0, 0],
  },

  headStyles: {
    fillColor: false,
    textColor: [0, 0, 0],
    fontStyle: "bold",
    fontSize: 9,
    lineColor: [0, 0, 0],
      lineWidth: 0.1,
    halign: "center"
  },

  footStyles: {
    fontStyle: "bold",
    fillColor: false,
    lineColor:[0,0,0],
    lineWidth:0.1,
  },


  columnStyles: {
    2: { halign: "left" }, 
  },

  didParseCell: (data: any) => {
    if (data.section === "body" && data.column.index === 5) {
      const val = Number(data.cell.text);
      if (val > 0) data.cell.styles.textColor = [200, 0, 0];
    }
  },

  didDrawPage: () => {
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageNumber = doc.getNumberOfPages();

    doc.setFontSize(8);
    doc.text(`Page ${pageNumber}`, pageWidth - 25, pageHeight - 8);
  },
});

  doc.save(
    `Total_Student_Fees_${batchFilter || "All"}_${
      new Date().toISOString().split("T")[0]
    }.pdf`
  );
};
  const downloadCSV = () => {
    if (!filteredStudents.length) return;

    const csvData = filteredStudents.map((student: any, index: number) => {
      const row: any = {
        "S.No": index + 1,
        "Admission No": student.admission_number,
        Name: student.student_name,
        "Total Due":student.grand_total,
        "Total Paid":student.grand_paid,
        "Total Balance":student.grand_balance,
      };

      // feeTitles.forEach((title) => {
      //   const fee = student.fees?.find((f: any) => f.title === title);

      //   row[`${title} Amount`] = fee?.total || 0;
      //   row[`${title} Balance`] = fee?.balance || 0;
      // });

      return row;
    });

    const csv = Papa.unparse(csvData);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");

    link.href = URL.createObjectURL(blob);
    link.download = "Total_Student_Fees_Summary.csv";
    link.click();
  };

  return (
    <>
      <Main>
        <PageContainer title="Total Wise Student Fees Summary">
          <Card title="Total Student Details">
            <div className="row mb-4">
              <div className="col-sm-6 col-md-4 col-lg-3">
                <label className="mt-3 mb-3">Branch:</label>
                <select
                  className="form-control form-select"
                  value={branchFilter}
                  onChange={(e) => setBranchFilter(e.target.value)}
                >
                  <option value="">Select Branch</option>
                  {branchList.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <label className="mt-3 mb-3">Course:</label>
                <select
                  className="form-control form-select"
                  value={courseFilter}
                  onChange={(e) => setCourseFilter(e.target.value)}
                >
                  <option value="">Select Course</option>
                  {courseList
                    .filter(
                      (fl) =>
                        fl.branchId.toString() === branchFilter.toString(),
                    )
                    .map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <label className="mt-3 mb-3">Batch:</label>
                <select
                  className="form-control form-select"
                  value={batchFilter}
                  onChange={(e) => setBatchFilter(e.target.value)}
                >
                  <option value="">Select Batch</option>
                  {last10Years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex align-items-end justify-content-end gap-2 mt-3 mb-3">
                <button
                  className="btn btn-primary"
                  onClick={handleFilterChange}
                  style={{ fontSize: "14px" }}
                >
                  Search
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={handleClear}
                  style={{ fontSize: "14px" }}
                >
                  Clear
                </button>
              </div>
            </div>
              <div className="d-flex justify-content-end gap-2 mb-3">
                <button className="btn btn-success" onClick={downloadPDF}
                style={{ fontSize: "14px" }}>
                   PDF
                </button>

                <button className="btn btn-success " onClick={downloadCSV}
                 style={{ fontSize: "14px" }}>
                 CSV
                </button>
              </div>
            <div
              className="table-container mt-5"
              style={{ maxHeight: "500px", overflowY: "auto" }}
            >
               
              {isSearched && filteredStudents.length > 0 && (
                <table className="table table-bordered table-striped text-center align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th rowSpan={2}>S.No</th>
                      <th rowSpan={2}>Admission No</th>
                      <th rowSpan={2}>Name</th>
                      <th rowSpan={2}>Total Due</th>
                      <th rowSpan={2}>Total Paid</th>
                      <th rowSpan={2}>Total Balance</th>



                      {/* {feeTitles.map((title: string, index: number) => (
                        <th key={index} colSpan={2}>
                          {title}
                        </th>
                      ))} */}
                    </tr>

                    {/* <tr>
                      {feeTitles.map((_, index) => (
                        <React.Fragment key={index}>
                          <th>Due</th>
                          <th>Balance</th>
                        </React.Fragment>
                      ))}
                    </tr> */}
                  </thead>

                  <tbody>
                    {filteredStudents.map((student: any, index: number) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{student.admission_number}</td>
                        <td>{student.student_name}</td>
                        <td>{(student.grand_total).toFixed(2)}</td>
                        <td>{(student.grand_paid).toFixed(2)}</td>
                        <td>{student.grand_balance.toFixed(2)}</td>


                        {/* {feeTitles.map((title: string, i: number) => {
                          const fee = student.fees?.find(
                            (f: any) => f.title === title,
                          );

                          return (
                            <React.Fragment key={i}>
                              <td>{fee?.total || 0}</td>
                              <td>{fee?.balance || 0}</td>
                            </React.Fragment>
                          );
                        })} */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </Card>
        </PageContainer>
      </Main>
    </>
  );
};

export default TotalStudentFeesSummary;
